class CheckoutConfirmDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CheckoutConfirmDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.checkoutAgree = window.sessionStorage.getItem("checkoutAgree") || "false";
  }

  open(triggeredBy) {
    console.log('this', this.checkoutAgree);
    if (this.checkoutAgree === "true") {
      this.agreeAndSubmit()
      return;
    }
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  agreeAndSubmit() {
    console.log('agreeAndSubmit');
    const submitCart = document.querySelector("#CartDrawer-Checkout");
    // Set cookie
    window.sessionStorage.setItem("checkoutAgree", "true");
    submitCart.click();
  }

  renderContents() {
    setTimeout(() => {
      this.querySelector('#CheckoutConfirmDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('checkout-confirm-drawer', CheckoutConfirmDrawer);